/** Rechnungsstatus – getrennt von Buchungsstatus (eigene Entität). */

export type InvoiceStatus =
  | "draft"
  | "issued"
  | "partially_paid"
  | "paid"
  | "cancelled";

export const INVOICE_STATUS_LABELS: Record<InvoiceStatus, string> = {
  draft: "Entwurf",
  issued: "Ausgestellt",
  partially_paid: "Teilweise bezahlt",
  paid: "Bezahlt",
  cancelled: "Storniert",
};

export function invoiceStatusLabel(status: string): string {
  const key = status.toLowerCase().replace(/\s+/g, "_") as InvoiceStatus;
  return INVOICE_STATUS_LABELS[key] ?? status.replace(/_/g, " ");
}

export function isInvoiceFinalized(status: string): boolean {
  return ["issued", "partially_paid", "paid"].includes(status);
}
